import { OwnershipSplitType } from '@app/shared/models/contracts/enums/shared-enums';
import { CellType } from '../types';

/**
 * Determines the type of cell to render based on split type and ownership context
 */
export const getCellType = (
  renderingSplitType: OwnershipSplitType,
  isProRata: boolean
): CellType => {
  if (renderingSplitType === OwnershipSplitType.ProRata && isProRata) {
    return CellType.EDITABLE;
  }

  if (renderingSplitType === OwnershipSplitType.Manual && !isProRata) {
    return CellType.EDITABLE;
  }

  if (renderingSplitType === OwnershipSplitType.Manual && isProRata) {
    return CellType.READ_ONLY;
  }

  if (renderingSplitType === OwnershipSplitType.ProRata && !isProRata) {
    return CellType.READ_ONLY;
  }

  return CellType.EMPTY;
};
